import { render, staticRenderFns } from "./product_series.vue?vue&type=template&id=9ddcf454&scoped=true"
import script from "./product_series.vue?vue&type=script&lang=js"
export * from "./product_series.vue?vue&type=script&lang=js"
import style0 from "./product_series.vue?vue&type=style&index=0&id=9ddcf454&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddcf454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ddcf454')) {
      api.createRecord('9ddcf454', component.options)
    } else {
      api.reload('9ddcf454', component.options)
    }
    module.hot.accept("./product_series.vue?vue&type=template&id=9ddcf454&scoped=true", function () {
      api.rerender('9ddcf454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/product_adjustment/form/product_series.vue"
export default component.exports